//========================================================================================================
// Use the css variables to edit exposed styles for this component
// Font styles can be inherited from the parent element
//========================================================================================================

(() => {
    const { defineCustomElement, ref, watch, onMounted } = Vue;

    const TextDisplay = defineCustomElement({
        props: ["text"],
        template: `
            <span>
                {{ displayText }}
            </span>
        `,
        setup(props) {
            const displayText = ref("");

            onMounted(() => {
                displayText.value = props.text;
            });

            watch(() => props.text, (newValue) => {
                displayText.value = newValue;
            });

            return { displayText };
        },
    });

    customElements.define("vue-text-display", TextDisplay);
})();
